$(document).ready(function () {
  function addImageAltTag() {
    $('img').each(function (i, elem) {
      if (!$(elem).attr('alt') || $.trim($(elem).attr('alt')) === '') {
        if ($(elem).css('display') == 'none' || $(elem).css("visibility") == "hidden") {
          $(elem).attr('alt', 'Dynamically generated alt text for hidden image');
        } else {
          $(elem).attr('alt', 'Dynamically generated alt text for image');
        }
      }
    })
  }
  for (var i = 0; i < 5; i++) {
    setTimeout(addImageAltTag, 2000 * i);
  }
});

const responsiveImage = () => {
  $('img').each(function () {
    const img = $(this);
    if (img.attr('data-desktop-src') && img.attr('data-mobile-src')) {
      if ($(window).width() > 667) {
        img.attr('src', img.attr('data-desktop-src'));
      } else {
        img.attr('src', img.attr('data-mobile-src'));
      }
    } else if (img.attr('data-desktop-src') === '' && img.attr('data-mobile-src')) {
      if ($(window).width() > 667) {
        $(this).parents('.hero').css('background', $(this).parents('.hero').attr('data-theme'));
      } else {
        img.attr('src', img.attr('data-mobile-src'));
      }
    } else if (img.attr('data-mobile-src') === '' && img.attr('data-desktop-src') === '') {
      $(this).parents('.hero').css('background', $(this).parents('.hero').attr('data-theme'));
    } else {
      const imgSrc = img.attr('data-mobile-src') || img.attr('data-desktop-src');
      img.attr('src', imgSrc);
    }
  });
};

export default responsiveImage;
